module.exports = __webpack_public_path__ + "img/hand.fae8a3d5.svg";